import { render } from "./YearBookSettingsModal.vue?vue&type=template&id=c1214ed6&ts=true"
import script from "./YearBookSettingsModal.vue?vue&type=script&lang=ts"
export * from "./YearBookSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__